export const sessionInvalidatedEvent = 'apl-enterprise:session-invalidated'
const sessionInvalidatedHeader = 'X-APL-Session-Invalidated'

/** Protected API request that broadcasts authentication loss to the shell. */
export async function apiFetch(input: RequestInfo | URL, init?: RequestInit) {
  const response = await fetch(input, init)
  // A feature endpoint may return 401 because of a local authorization or
  // identity-mapping error. Only the authentication middleware can confirm
  // that the persisted browser session itself is no longer active.
  if (response.status === 401 &&
      response.headers.get(sessionInvalidatedHeader) === 'true') {
    window.dispatchEvent(new Event(sessionInvalidatedEvent))
  }
  return response
}
